import React from 'react';
import { ConfirmModal, ConfirmModalProps } from './ConfirmModal';

export type ConfirmDeleteModalProps = Omit<
    ConfirmModalProps,
    'confirmText' | 'variant' | 'title'
> & {
    itemLabel?: string;
    itemTitle?: string;
    count?: number;
};

export function ConfirmDeleteModal({
    itemLabel,
    itemTitle,
    count,
    details,
    children,
    ...rest
}: ConfirmDeleteModalProps) {
    const defaultDetails = (
        <p>
            {count && count > 1 ? (
                <>
                    Are you sure you want to permanently delete {count}{' '}
                    {itemLabel}(s)? This action cannot be undone.
                </>
            ) : (
                <>
                    Are you sure you want to permanently delete this{' '}
                    <strong className="text-neutral-100">{itemLabel}</strong>?
                    This action cannot be undone.
                </>
            )}
        </p>
    );

    return (
        <ConfirmModal
            title={`Delete ${count && count > 1 ? `${itemLabel}s` : itemLabel} Permanently`}
            confirmText={`Delete ${count && count > 1 ? `${itemLabel}s` : itemLabel}`}
            variant="danger"
            itemLabel={itemLabel}
            itemTitle={itemTitle}
            count={count}
            details={children ?? details ?? defaultDetails}
            {...rest}
        />
    );
}


